export default {
    title: 'События Яндекса',
    description: 'События — вся информация о конференциях, школах, семинарах и других мероприятиях Яндекса' +
    ' — как прошедших, так и предстоящих.',
    keywords: 'яндекс, события, конференции, вебинары, субботник, yac, научно-технические семинары'
};
